function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 3l2.82 6.18L21 12l-6.18 2.82L12 21l-2.82-6.18L3 12l6.18-2.82L12 3zm8-3l1.253 2.747L24 4l-2.747 1.253L20 8l-1.253-2.747L16 4l2.747-1.253L20 0z"
});
const SvgIconDevIcContentPremium = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDevIcContentPremium, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-dev-ic-content-premium.f140e446.svg";
export { ForwardRef as ReactComponent };